const navTriggers = document.querySelectorAll('[id^="subnav-trigger-"]')

const headerTop = document.querySelector('.header__top')
const headerBottom = document.querySelector('.header__bottom')
let triggerTimeoutId = null

navTriggers.forEach(trigger => {
  trigger.addEventListener('mouseenter', onPointerenterTrigger)
  // trigger.addEventListener('mouseleave', onPointerleaveTrigger)
})

function onPointerenterTrigger(event) {
  const target = event.target

  closeAllSubnav()

  if (!!target.id) {
      // console.log('onPointerenterTrigger')
      clearTimeout(triggerTimeoutId)
  
    setTimeout(() => {
      target.addEventListener('mouseleave', onPointerleaveTrigger)
    }, 100);

    const subnav = getSubnavByTrigger(target)
    subnav.classList.add('active')
    headerTop.classList.add('header__top_black')
    headerBottom.classList.add('header__bottom_black')

    document.querySelector('.navigation__list-item_subnav_hover')?.classList.remove("navigation__list-item_subnav_hover");
    event.target.classList.add("navigation__list-item_subnav_hover");

    subnav.addEventListener('mouseenter', onPointerenterSubnav)
    subnav.addEventListener('mouseleave', onPointerleaveSubnav)
  }
}

function onPointerleaveTrigger(event) {
  // console.log('onPointerleaveTrigger')
  const target = event.target

  triggerTimeoutId = setTimeout(() => {
    const subnav = getSubnavByTrigger(target)
    subnav.classList.remove('active')
    headerTop.classList.remove('header__top_black')
    headerBottom.classList.remove('header__bottom_black')
    document.querySelector('.navigation__list-item_subnav_hover')?.classList.remove("navigation__list-item_subnav_hover");
  }, 800);

  // console.log(triggerTimeoutId)
}

function getSubnavByTrigger(trigger) {
  const id = parseFloat(trigger.id.split('').reverse().join(''))
  return document.querySelector(`[id="subnav-${id}"]`)
}

function onPointerenterSubnav(event) {
  const subnav = event.target
  // console.log(subnav)

  clearTimeout(triggerTimeoutId)

}

function onPointerleaveSubnav(event) {
  const subnav = event.target
  // console.log(subnav)
  subnav.classList.remove('active')
  headerTop.classList.remove('header__top_black')
  headerBottom.classList.remove('header__bottom_black')

  document.querySelector('.navigation__list-item_subnav_hover').classList.remove("navigation__list-item_subnav_hover");
}

function closeAllSubnav() {
  const subnavs = document.querySelectorAll('.header__subnav')

  subnavs.forEach(subnav => {
    subnav.classList.remove('active')
    headerTop.classList.remove('header__top_black')
    headerBottom.classList.remove('header__bottom_black')
  })
}

const mobileMenu = document.querySelectorAll('.js-mobile-submenu');

if(mobileMenu) {
  mobileMenu.forEach(menu => {
    menu.addEventListener('click', () => {
      const item = menu.querySelector('.header-mobile__nav-list-item-menu')
      const submenu = menu.querySelector('.mobile-submenu')

      item.classList.toggle('open')

      if(submenu.scrollHeight < 185) {
        submenu.style.overflowY = 'hidden';
      }

      if(submenu.clientHeight > 0) {
        //submenu.style.paddingTop = '0px'
        submenu.style.maxHeight = '0px'
        submenu.style.marginTop = '0px'
        setTimeout(() => {
          submenu.style.width = '0px'
          submenu.style.overflowY = 'auto'; 
        }, 600)
      } else {

        //submenu.style.paddingTop = 20 + "px"; 

        if(submenu.scrollHeight < 185) {
          submenu.style.maxHeight = submenu.scrollHeight + 'px'
        } else {
          submenu.style.maxHeight = '385px'
        }
        submenu.style.marginTop = '20px'
        if(submenu.classList.contains('navigation__brands')) {
          submenu.style.width = '170px'
        } else {
          submenu.style.width = '145px'
        }
      }
    })
  })
}